/* Component Dependencies */
var welcomeMessageTemplate = require('templates/welcomeMessage.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'welcomeMessage',
  template: {
    'welcomeMessage': welcomeMessageTemplate
  }
});
